<template>
    <v-container>
        <v-tabs v-model="activeTab">
            <v-tab>Gestão de Usuários</v-tab>
            <v-tab>Grupos e Permissões</v-tab>

            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <v-card>
                            <v-card-title>
                                Gestão de grupos dos usuários
                            </v-card-title>
                            <v-card-text>
                                <v-data-table
                                    :footer-props="{ itemsPerPageOptions: [1, 5, 10] }"
                                    :headers="userHeaders"
                                    :items="users"
                                    :options.sync="options"
                                    :server-items-length="total"
                                    :loading="loadingUsers"
                                >
                                    <template v-slot:body.prepend>
                                        <tr>
                                            <td>
                                                <v-text-field
                                                    v-model="userName"
                                                    label="Buscar usuário..."
                                                    single-line
                                                    hide-details
                                                    @keyup.enter="getUserData()"
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="userEmail"
                                                    label="Buscar email..."
                                                    single-line
                                                    hide-details
                                                    @keyup.enter="getUserData()"
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-select
                                                    v-model="userGroup"
                                                    :items="roles"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Selecione os grupos"
                                                    multiple
                                                    chips
                                                    small-chips
                                                    hide-details
                                                    @change="getUserData()"
                                                ></v-select>
                                            </td>
                                            <td class="td-actions text-center">
                                                <v-btn class="mt-4" depressed width="80%" color="primary" @click="getUserData()">
                                                    Buscar
                                                </v-btn>
                                                <v-btn class="mb-4 mt-4" depressed width="80%" color="#FBC02D" @click="getCleanFilter()">
                                                    Limpar
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-slot:item.roles="{ item }">
                                        <div class="d-flex align-center">
                                            <div class="mr-2">
                                                <v-chip
                                                    v-for="role in item.roles"
                                                    :key="role.id"
                                                    class="mr-1 mb-1"
                                                    small
                                                    :color="getChipColor(role)"
                                                    text-color="white"
                                                >
                                                    {{ role.name }}
                                                </v-chip>
                                                <v-chip
                                                    v-if="!item.roles || item.roles.length === 0"
                                                    small
                                                    outlined
                                                    color="grey"
                                                >
                                                    Sem grupo
                                                </v-chip>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-menu offset-y :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn small icon v-bind="attrs" v-on="on" :loading="item.updating">
                                                    <v-icon small>mdi-pencil</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card min-width="300">
                                                <v-card-text>
                                                    <v-select
                                                        v-model="item.selectedRoles"
                                                        :items="roles"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Selecione os grupos"
                                                        multiple
                                                        chips
                                                        small-chips
                                                        :loading="item.updating"
                                                        :disabled="item.updating"
                                                        @change="updateUserRoles(item)"
                                                        persistent-hint
                                                        hint="Selecione um ou mais grupos"
                                                    >
                                                        <template v-slot:selection="{ item: role, index }">
                                                            <v-chip
                                                                v-if="index < 3"
                                                                small
                                                                :color="getChipColor(role)"
                                                                text-color="white"
                                                                class="mr-1"
                                                            >
                                                                {{ role.name }}
                                                            </v-chip>
                                                            <span v-else-if="index === 3" class="grey--text caption">
                                                                (+{{ item.selectedRoles.length - 3 }} outros)
                                                            </span>
                                                        </template>
                                                        <template v-slot:item="{ item: role }">
                                                            <v-chip
                                                                small
                                                                :color="getChipColor(role)"
                                                                text-color="white"
                                                                class="mr-2"
                                                            >
                                                                {{ role.name }}
                                                            </v-chip>
                                                        </template>
                                                    </v-select>
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-tab-item>

            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-card>
                                    <v-card-title>
                                        Grupos (Roles)
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="openRoleDialog">
                                            Adicionar Role
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-data-table :headers="roleHeaders" :items="roles" :loading="loading">
                                            <template v-slot:item.actions="{ item }">
                                                <v-btn small text color="primary" @click="editRole(item)">
                                                    Editar
                                                </v-btn>
                                                <v-btn small text color="error" @click="deleteRole(item)">
                                                    Deletar
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-card>
                                    <v-card-title>
                                        Permissões
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="openPermissionDialog">
                                            Adicionar Permissão
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-data-table :headers="permissionHeaders" :items="permissions" :loading="loading">
                                            <template v-slot:item.actions="{ item }">
                                                <v-btn small text color="primary" @click="editPermission(item)">
                                                    Editar
                                                </v-btn>
                                                <v-btn small text color="error" @click="deletePermission(item)">
                                                    Deletar
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>

        <v-dialog v-model="roleDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    {{ editedRole.id ? 'Editar' : 'Nova' }} Role
                </v-card-title>
                <v-card-text>
                    <v-form ref="roleForm" v-model="roleFormValid" @submit.prevent="saveRole">
                        <v-text-field
                            v-model="editedRole.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            label="Nome da Role"
                            required
                        ></v-text-field>
                        <v-select
                            v-model="editedRole.permissions"
                            :items="permissions"
                            :rules="[v => v.length > 0 || 'Selecione ao menos uma permissão']"
                            item-text="name"
                            item-value="id"
                            label="Permissões"
                            multiple
                            chips
                            required
                        ></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeRoleDialog">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="saveRole" :disabled="!roleFormValid">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="permissionDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    {{ editedPermission.id ? 'Editar' : 'Nova' }} Permissão
                </v-card-title>
                <v-card-text>
                    <v-form ref="permissionForm" v-model="permissionFormValid" @submit.prevent="savePermission">
                        <v-text-field
                            v-model="editedPermission.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            label="Nome da Permissão"
                            required
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closePermissionDialog">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="savePermission" :disabled="!permissionFormValid">
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <response-dialog
            :model="responseDialog"
            :message="responseMessage"
            :type="responseType"
            @close="closeResponseDialog"
        />
    </v-container>
</template>

<script>
import ResponseDialog from "../../components/Dialog/ResponseDialog.vue";

export default {
    components: {
        ResponseDialog
    },
    data: () => ({
        activeTab: 0,
        loading: false,
        loadingUsers: false,
        userName: '',
        userEmail: '',
        userGroup: [],
        roles: [],
        permissions: [],
        users: [],
        roleDialog: false,
        permissionDialog: false,
        responseDialog: false,
        responseMessage: '',
        responseType: '',
        roleColors: [
            'red darken-2', 'blue darken-2', 'blue', 'green darken-2', 'green',
            'purple darken-2', 'purple', 'orange darken-2', 'orange',
            'teal darken-2', 'teal', 'pink darken-2', 'pink',
            'indigo darken-2', 'indigo',
        ],
        fixedRoleColors: {
            'admin': 'red darken-2',
            'leadersourcing': 'blue darken-2',
            'sourcing': 'blue',
            'leaderemissions': 'green darken-2',
            'emissions': 'green',
            'leaderservice': 'purple darken-2',
            'service': 'purple'
        },
        roleHeaders: [
            { text: 'Nome', value: 'name' },
            { text: 'Ações', value: 'actions', sortable: false }
        ],
        permissionHeaders: [
            { text: 'Nome', value: 'name' },
            { text: 'Ações', value: 'actions', sortable: false }
        ],
        userHeaders: [
            { text: 'Nome', value: 'name' },
            { text: 'Email', value: 'email' },
            { text: 'Grupos', value: 'roles', sortable: false },
            { text: 'Ações', value: 'actions', sortable: false }
        ],
        editedRole: {
            id: null,
            name: '',
            permissions: []
        },
        editedPermission: {
            id: null,
            name: ''
        },
        total: 0,
        options: {
            sortDesc: [true],
        },
        roleFormValid: false,
        permissionFormValid: false,
    }),

    mounted() {
        if (Object.keys(this.$route.query).length) {
            const { sort, sortDesc, page, perPage, userName, userEmail, userGroup } = this.$route.query;
            if (sort) this.options.sortBy = sort;
            if (sortDesc) this.options.sortDesc = sortDesc;
            if (page) this.options.page = parseInt(page);
            if (perPage) this.options.perPage = perPage;
            if (userName) this.userName = userName;
            if (userEmail) this.userEmail = userEmail;
            if (userGroup) {
                this.userGroup = [...new Set(userGroup.split(',').map(id => Number(id)).filter(Boolean))];
            }
        }
    },

    created() {
        this.initialize()
    },

    watch: {
        options: {
            handler() {
                this.getUserData()
            },
            deep: true,
        }
    },

    methods: {
        getCleanFilter() {
            this.$router.replace({ 'query': null });
            window.location.reload();
        },

        async initialize() {
            this.loading = true;
            try {
                const [rolesResponse, permissionsResponse] = await Promise.all([
                    axios.get('/api/roles'),
                    axios.get('/api/permissions')
                ]);
                this.roles = rolesResponse.data.data;
                this.permissions = permissionsResponse.data.data;
            } catch (error) {
                this.showResponse('Erro ao carregar dados. Por favor, tente novamente.', 'error');
                console.error('Erro ao carregar dados:', error);
            }
            this.loading = false;
        },

        async getUserData() {
            this.loadingUsers = true;
            try {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options;

                const queryParams = {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    userName: this.userName,
                    userEmail: this.userEmail,
                    userGroup: this.userGroup.length > 0 ? [...new Set(this.userGroup)].join(',') : null
                };

                this.$router.push({ query: queryParams });

                const queryString = new URLSearchParams(queryParams).toString();
                const usersResponse = await axios.get(`/api/user/list?${queryString}`);
                this.total = usersResponse.data.total;

                this.users = usersResponse.data.data.map(user => {
                    const userRoles = user.roles || [];
                    return {
                        ...user,
                        selectedRoles: userRoles.map(role => role.id),
                        updating: false
                    };
                });

            } catch (error) {
                this.showResponse('Erro ao carregar usuários. Por favor, tente novamente.', 'error');
                console.error('Erro ao carregar usuários:', error);
            }
            this.loadingUsers = false;
        },

        async updateUserRoles(user) {
            const originalRoles = user.roles ? user.roles.map(role => role.id) : [];
            user.updating = true;

            try {
                const rolesToRemove = originalRoles.filter(roleId => !user.selectedRoles.includes(roleId));
                const rolesToAdd = user.selectedRoles.filter(roleId => !originalRoles.includes(roleId));

                await Promise.all([
                    ...rolesToRemove.map(roleId =>
                        axios.post('/api/roles/remove-from-user', {
                            user_id: user.id,
                            role_id: roleId
                        })
                    ),
                    ...rolesToAdd.map(roleId =>
                        axios.post('/api/roles/assign-to-user', {
                            user_id: user.id,
                            role_id: roleId
                        })
                    )
                ]);
                
                this.showResponse('Grupos do usuário atualizados com sucesso!', 'success');
            } catch (error) {
                user.selectedRoles = originalRoles;
                this.showResponse('Erro ao atualizar grupos do usuário. Por favor, tente novamente.', 'error');
                console.error('Erro ao atualizar roles do usuário:', error);
            }

            user.updating = false;
        },

        openRoleDialog() {
            this.roleDialog = true;
            this.editedRole = { id: null, name: '', permissions: [] };
        },

        openPermissionDialog() {
            this.permissionDialog = true;
            this.editedPermission = { id: null, name: '' };
        },

        async saveRole() {
            if (!this.$refs.roleForm.validate()) return;

            try {
                if (this.editedRole.id) {
                    await axios.put(`/api/roles/${this.editedRole.id}`, {
                        name: this.editedRole.name
                    });
                    await axios.post(`/api/roles/sync-permissions/${this.editedRole.id}`, {
                        permissions: this.editedRole.permissions
                    });
                    this.showResponse('Grupo atualizado com sucesso!', 'success');
                } else {
                    await axios.post('/api/roles', {
                        name: this.editedRole.name,
                        permissions: this.editedRole.permissions
                    });
                    this.showResponse('Grupo criado com sucesso!', 'success');
                }
                this.closeRoleDialog();
                this.initialize();
            } catch (error) {
                const errorMessage = this.handleRoleValidationError(error);
                this.showResponse(errorMessage, 'error');
                console.error('Erro ao salvar role:', error);
            }
        },

        async savePermission() {
            if (!this.$refs.permissionForm.validate()) return;

            try {
                if (this.editedPermission.id) {
                    await axios.put(`/api/permissions/${this.editedPermission.id}`, {
                        name: this.editedPermission.name
                    });
                    this.showResponse('Permissão atualizada com sucesso!', 'success');
                } else {
                    await axios.post('/api/permissions', {
                        name: this.editedPermission.name
                    });
                    this.showResponse('Permissão criada com sucesso!', 'success');
                }
                this.closePermissionDialog();
                this.initialize();
            } catch (error) {
                const errorMessage = this.handleValidationError(error);
                this.showResponse(errorMessage, 'error');
                console.error('Erro ao salvar permissão:', error);
            }
        },

        editRole(item) {
            this.editedRole = Object.assign({}, item)
            this.roleDialog = true
        },

        editPermission(item) {
            this.editedPermission = Object.assign({}, item)
            this.permissionDialog = true
        },

        async deleteRole(item) {
            if (confirm('Tem certeza que deseja deletar esta role?')) {
                try {
                    await axios.delete(`/api/roles/${item.id}`);
                    this.showResponse('Grupo excluído com sucesso!', 'success');
                    this.initialize();
                } catch (error) {
                    this.showResponse('Erro ao excluir grupo. Por favor, tente novamente.', 'error');
                    console.error('Erro ao deletar role:', error);
                }
            }
        },

        async deletePermission(item) {
            if (confirm('Tem certeza que deseja deletar esta permissão?')) {
                try {
                    await axios.delete(`/api/permissions/${item.id}`);
                    this.showResponse('Permissão excluída com sucesso!', 'success');
                    this.initialize();
                } catch (error) {
                    this.showResponse('Erro ao excluir permissão. Por favor, tente novamente.', 'error');
                    console.error('Erro ao deletar permissão:', error);
                }
            }
        },

        closeRoleDialog() {
            this.roleDialog = false;
            this.$refs.roleForm.reset();
            this.$nextTick(() => {
                this.editedRole = { id: null, name: '', permissions: [] };
            });
        },

        closePermissionDialog() {
            this.permissionDialog = false;
            this.$refs.permissionForm.reset();
            this.$nextTick(() => {
                this.editedPermission = { id: null, name: '' };
            });
        },

        getChipColor(role) {
            const fixedColor = this.fixedRoleColors[role.name.toLowerCase()];
            if (fixedColor) return fixedColor;
            const roleIndex = this.roles.findIndex(r => r.id === role.id);
            return this.roleColors[roleIndex % this.roleColors.length];
        },

        showResponse(message, type) {
            this.responseMessage = message;
            this.responseType = type;
            this.responseDialog = true;
        },

        closeResponseDialog() {
            this.responseDialog = false;
            this.responseMessage = '';
            this.responseType = '';
            this.reloadPage();
        },

        handleValidationError(error) {
            if (error.response?.data?.fields) {
                const fields = error.response.data.fields;
                if (fields.name?.includes('The name has already been taken.')) {
                    return 'Já existe uma permissão com este nome.';
                }
                if (fields.name?.includes('The name field is required.')) {
                    return 'O nome da permissão é obrigatório.';
                }
                return Object.values(fields).flat().join('\n');
            }
            return error.response?.data?.message || 'Erro ao salvar permissão.';
        },

        handleRoleValidationError(error) {
            if (error.response?.data?.fields) {
                const fields = error.response.data.fields;
                if (fields.name?.includes('The name has already been taken.')) {
                    return 'Já existe um grupo com este nome.';
                }
                if (fields.name?.includes('The name field is required.')) {
                    return 'O nome do grupo é obrigatório.';
                }
                if (fields.permissions?.includes('The permissions field is required.')) {
                    return 'Selecione pelo menos uma permissão para o grupo.';
                }
                return Object.values(fields).flat().join('\n');
            }
            return error.response?.data?.message || 'Erro ao salvar grupo.';
        },

        reloadPage () {
            window.location.reload();
            this.$forceUpdate();
        }
    }
}
</script>

